import { streamKind } from "./stream-kind";

export const streamKinds = {
  type: "array",
  minItems: 0,
  maxItems: 2,
  items: streamKind
};
